import { CDK_VIRTUAL_SCROLL_VIEWPORT } from '@angular/cdk/scrolling';
import { Component } from '@angular/core';

/**
 * Temproray fix for the cdk-virtual-scroll-viewport glitch.
 * https://github.com/angular/components/issues/32715 for more details.
 * TODO: to be removed
 */
/* eslint-disable @angular-eslint/component-selector */
@Component({
  providers: [{ provide: CDK_VIRTUAL_SCROLL_VIEWPORT, useValue: null }],
  selector: 'cdk-virtual-scroll-viewport-wrapper',
  template: '<ng-content />',
})
export class CdkVirtualScrollViewportWrapperComponent { }
